import React from 'react'
import { FormattedMessage } from 'react-intl'
import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { WithTooltip, tooltipTitleCss } from '../../design-system'
import { CsSendToBugTrackerSyslogIcon } from '../../legacy-design-system/icons'

const iconCss = css`
  color: ${theme.color.neutral60};
`

const tooltipContainerCss = css`
  max-width: 200px;
`

interface Props {
  readonly ipAddress: string
}

export function SyslogIndicator({ ipAddress }: Props) {
  return (
    <WithTooltip
      children={() => {
        return <CsSendToBugTrackerSyslogIcon className={iconCss} />
      }}
      renderTooltipContent={() => {
        return (
          <div className={tooltipContainerCss}>
            <FormattedMessage
              id="title_servers_outputToSyslog"
              defaultMessage="Output to Syslog"
            >
              {(text) => <div className={tooltipTitleCss}>{text}</div>}
            </FormattedMessage>
            <FormattedMessage
              id="variable_servers_protectEventsOutput_component"
              defaultMessage="Protect events are being output to {ipAddress}"
              values={{ ipAddress }}
            >
              {(text) => <div>{text}</div>}
            </FormattedMessage>
          </div>
        )
      }}
    />
  )
}
